import { prefixer, createApiConsts } from '../../../Helpers/constants'

const createPrefixedConst = prefixer('EVALUATION_FORM')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const GET_ACTIVE_EVALUATION_FORMS = createPrefixedApiConsts('GET_ACTIVE_EVALUATION_FORMS')

export const EVAL_STATE = {
  UNSCORED: 0,
  SCORED: 1,
  IN_PROGRESS: 2,
  NEEDS_APPROVAL: 3,
  CANNOT_SCORE: 4,
  NEEDS_CANNOT_SCORE_APPROVAL: 5,
} as const

export type EvalStateKey = keyof typeof EVAL_STATE
export type EvalStateValue = typeof EVAL_STATE[EvalStateKey]

export const RESPONSE_TYPE = {
  NONE: 1,
  ACKNOWLEDGE: 2,
  APPEAL: 3,
} as const

export type ResponseTypeKey = keyof typeof RESPONSE_TYPE
export type ResponseTypeValue = typeof RESPONSE_TYPE[ResponseTypeKey]

export const RESPONSE_STATE = {
  PENDING_RESPONSE: 1,
  ACKNOWLEDGED: 2,
  APPEALED: 3,
} as const

export type ResponseStateKey = keyof typeof RESPONSE_STATE
export type ResponseStateValue = typeof RESPONSE_STATE[ResponseStateKey]

export const SCORE_TYPE = {
  PERCENTAGE: 1,
  POINTS: 2,
} as const

export type ScoreTypeKey = keyof typeof SCORE_TYPE
export type ScoreTypeValue = typeof SCORE_TYPE[ScoreTypeKey]

export const ANSWER_TYPE = {
  NOT_APPLICABLE: 'NOTAPPLICABLE',
} as const

export type AnswerTypeKey = keyof typeof ANSWER_TYPE
export type AnswerTypeValue = typeof ANSWER_TYPE[AnswerTypeKey]
